/* es5-ext/array/#/clear */ function _(require, module, exports) {
    var value = require(359) /* ../../object/valid-value */;
    module.exports = function () {
        value(this).length = 0;
        return this;
    };
}
